import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";

import { StedIcon } from "@/assets/icons";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-primary/20 text-primary pt-16 pb-8'>
      <div className='container mx-auto px-4'>
        {/* Main Footer Content */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12'>
          {/* Company Info */}
          <div>
            <h3 className='text-xl font-bold mb-4'>Our Company</h3>
            <div className='mb-4'>
              <StedIcon size='md' />
              <p className='text-gray-700 pt-4 mb-4'>
                Your trusted destination for premium products with unmatched quality and service.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className='text-xl font-bold mb-4'>Quick Links</h3>
            <ul className='space-y-2'>
              <li>
                <Link to='/' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Home
                </Link>
              </li>
              <li>
                <Link to='/shop' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to='/categories'
                  className='text-gray-800 hover:text-gray-500 transition-colors'
                >
                  Categories
                </Link>
              </li>
              {/* <li>
                <Link to='/about' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  About Us
                </Link>
              </li> */}
              {/* <li>
                <Link to='/blog' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Blog
                </Link>
              </li> */}
              <li>
                <Link to='/contact' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className='text-xl font-bold mb-4'>Customer Service</h3>
            <ul className='space-y-2'>
              <li>
                <Link to='/profile' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  My Account
                </Link>
              </li>
              <li>
                <Link to='/orders' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Track Order
                </Link>
              </li>
              <li>
                <Link
                  to='/wishlist'
                  className='text-gray-800 hover:text-gray-500 transition-colors'
                >
                  Wishlist
                </Link>
              </li>
              <li>
                <Link
                  to='/shipping-policy'
                  className='text-gray-800 hover:text-gray-500 transition-colors'
                >
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link
                  to='/return-policy'
                  className='text-gray-800 hover:text-gray-500 transition-colors'
                >
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to='/returns' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  Returns & Refunds
                </Link>
              </li>
              <li>
                <Link to='/faq' className='text-gray-800 hover:text-gray-500 transition-colors'>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className='text-xl font-bold mb-4'>Contact Us</h3>
            <ul className='space-y-4'>
              {/* <li className='flex items-start'>
                <MapPin size={20} className='mr-3 text-primary shrink-0 mt-1' />
                <span className='text-gray-800'>
                  123 Commerce Street, Business District, City, Country
                </span>
              </li> */}
              <li className='flex items-center'>
                <Phone size={20} className='mr-3 text-primary shrink-0' />
                <a
                  href='tel:+1234567890'
                  className='text-gray-800 hover:text-white transition-colors'
                >
                  09021893212
                </a>
              </li>
              <li className='flex items-center'>
                <Mail size={20} className='mr-3 text-primary shrink-0' />
                <a
                  href='mailto:support@company.com'
                  className='text-gray-800 hover:text-white transition-colors'
                >
                 support@stedshop.com.ng
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className='border-t border-gray-800 pt-8 pb-16'>
          <div className='flex flex-col md:flex-row justify-between items-center'>
            <div className='text-gray-800 text-sm mb-4 md:mb-0'>
              © {currentYear} StedShop LTD. All rights reserved.
            </div>
            <div className='flex space-x-4 text-sm text-gray-800'>
              <Link
                to='/privacy-policy'
                className=' hover:text-gray-500 underline transition-colors'
              >
                Privacy Policy
              </Link>
              <Link
                to='/terms-of-service'
                className='hover:text-gray-500 underline transition-colors'
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
